<template>
  <form
    class="row snkbx-form"
    name="sneakers-order"
    data-netlify="true"
    data-netlify-honeypot="bot-field"
    method="post"
    @submit.prevent="submitForm"
  >
    <input type="hidden" name="form-name" value="sneakers-order" />
    <div class="col-xs-6">
      <label for="userPrenom">Prénom</label>
      <input
        type="text"
        name="userPrenom"
        id="userPrenom"
        placeholder="Michael"
        v-model="form.userPrenom"
        required
      />
    </div>
    <div class="col-xs-6">
      <label for="userNom">Nom</label>
      <input
        type="text"
        name="userNom"
        id="userNom"
        placeholder="Jordan"
        v-model="form.userNom"
        required
      />
    </div>
    <div class="col-xs-10">
      <label for="userTel">Téléphone</label>
      <input
        type="tel"
        name="userTel"
        id="userTel"
        placeholder="06 63 58 96 42"
        v-model="form.userTel"
        required
      />
    </div>
    <div class="col-xs-12">
      <label for="userAdresse">Adresse</label>
      <input
        type="text"
        name="userAdresse"
        id="userAdresse"
        placeholder="14 rue de pont levis"
        v-model="form.userAdresse"
        required
      />
    </div>
    <div class="col-xs-6">
      <label for="userCity">Ville</label>
      <input
        type="text"
        placeholder="Paris"
        name="userCity"
        id="userCity"
        v-model="form.userCity"
        required
      />
    </div>
    <div class="col-xs-6">
      <label for="userPostal">Code postal</label>
      <input
        type="text"
        placeholder="75003"
        name="userPostal"
        id="userPostal"
        v-model="form.userPostal"
        required
      />
    </div>
    <stripe-checkout
      ref="checkoutRef"
      :pk="publishableKey"
      :items="items"
      :successUrl="successUrl"
      :cancelUrl="cancelUrl"
    >
      <template slot="checkout-button">
        <Button class="basket__btn" type="submit" secondary>
          Confirmer
        </Button>
      </template>
    </stripe-checkout>
  </form>
</template>
<script>
import { StripeCheckout } from "vue-stripe-checkout";
import Button from "@/components/Common/Button";
import { mapState, mapMutations, mapActions } from "vuex";
import { encode } from "@/plugins/helpers";
export default {
  name: "BasketForm",
  components: {
    StripeCheckout,
    Button
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    shoe: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        shoeID: this.shoe.id,
        shoeName: this.shoe.name,
        shoeImage: this.shoe.images[0],
        userSize: this.user.size + " EU",
        userPrenom: this.user.name,
        userNom: this.user.surname,
        userMail: this.user.mail,
        userTel: this.user.tel,
        userAdresse: this.user.adresse,
        userCity: this.user.city,
        userPostal: this.user.zipCode
      }
    };
  },
  computed: {
    ...mapState({
      publishableKey: state => state.stripe.publishableKey,
      items: state => state.stripe.items,
      successUrl: state => state.stripe.successUrl,
      cancelUrl: state => state.stripe.cancelUrl
    })
  },
  methods: {
    ...mapMutations({
      updatePopinError: "updatePopinError"
    }),
    ...mapActions({
      saveErrorStorage: "saveErrorStorage"
    }),
    submitForm() {
      console.log("submit");
      fetch("/", {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: encode({
          "form-name": "sneakers-order",
          ...this.form
        })
      })
        .then(() => {
          // this.updatePopinError(true);
          // this.saveErrorStorage();
          // this.$router.push("/checkout");
          this.$refs.checkoutRef.redirectToCheckout();
        })
        .catch(e => {
          console.log("form error");
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss">
.basket {
  &__btn {
    text-transform: uppercase;
    margin: 2rem auto 0;
    padding: 1.5rem 5rem;
    @media #{$md-and-down} {
      margin-bottom: 2rem;
    }
  }
}
.snkbx-form {
  &__hidden {
    display: none;
  }
  > div {
    padding: 1rem;
  }
  label {
    display: block;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }
  input {
    padding: 1rem;
    border: 1px solid get($theme, "border");
    border-radius: get($radius, "arrounded");
    box-sizing: border-box;
    width: 100%;
    transition: border get($times, "fast");
    &:focus {
      outline-color: rgba(0, 0, 0, 0);
      border-color: get($theme, "primary");
    }
    &::placeholder {
      color: #dadada;
    }
  }
}
</style>
